import React from "react";
import {useQuery} from "@tanstack/react-query";
import {Modal} from "../../../../components/modal/modal.jsx";
import GarrisonService from "../../../../services/dispatch/garrison-service.js";
import {DASHBOARD_QUERY_KEYS} from "../utils/dashboard-query-keys.js";
import GarrisonScheduleList from "../../utils/components/garrison-schedule-list.jsx";
import Loader from "../../../../components/template/loader.jsx";
import useDashboardModalState from "../hooks/use-dashboard-modal-state.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";

const DESPACHO_WEB_URL = import.meta.env.VITE_API_DESPACHO_WEB;

const hasValue = value => value !== null && value !== undefined && value !== "";

const GarrisonScheduleModal = ({payload, onClose, onDispatchActivity}) => {
    const navigate = navigateHook();
    const requested = Boolean(payload);
    const garrison = payload?.garrison;
    const garrisonId = garrison?.garrisonId;
    const garrisonName = garrison?.garrisonName ?? garrison?.name ?? "";
    const garrisonStart = garrison?.garrisonStart ?? garrison?.startText ?? garrison?.dispatchStart ?? "";

    const scheduleQuery = useQuery({
        queryKey: DASHBOARD_QUERY_KEYS.garrisonSchedule(garrisonId),
        queryFn: () => GarrisonService.getGarrisonSchedule(garrisonId),
        enabled: requested && hasValue(garrisonId),
    });
    const isReady = !scheduleQuery.isFetching && (scheduleQuery.isSuccess || scheduleQuery.isError);
    const {open, closeModal, isPreparing} = useDashboardModalState({payload, isReady, onClose});

    const schedules = Array.isArray(scheduleQuery.data) ? scheduleQuery.data : [];

    const openDispatch = () => {
        const url = `${DESPACHO_WEB_URL}/garrison/form/${garrisonId}`
        navigate(url, true);
    }

    return (
        <>
            {isPreparing && <Loader/>}
            <Modal open={open} setOpen={closeModal} title="Atividades programadas" className="w-11/12" isCloseClick={!scheduleQuery.isFetching} animated={false}>
                <Modal.Body className="flex max-h-[calc(100vh-180px)] flex-col gap-3 overflow-auto">
                    <div>
                        <p className="text-[16px] font-semibold text-[#676a6c]">Guarnição</p>
                        <p className="cursor-pointer text-[#428bca] hover:underline" onClick={openDispatch}>
                            {garrisonName}{garrisonStart ? ` - Início ${garrisonStart}` : ""}
                        </p>
                    </div>

                    {scheduleQuery.isError && (
                        <div className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">
                            Não foi possível carregar as atividades programadas da guarnição.
                        </div>
                    )}

                    {!scheduleQuery.isFetching && !scheduleQuery.isError && schedules.length === 0 && (
                        <h4 className="text-center text-[16px] font-semibold text-[#676a6c]">
                            Não há atividades a serem listadas para essa guarnição
                        </h4>
                    )}

                    {!scheduleQuery.isFetching && !scheduleQuery.isError && (
                        <GarrisonScheduleList
                            schedules={schedules}
                            onDispatchActivity={({schedule, activity}) => onDispatchActivity?.({garrison, schedule, activity})}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default GarrisonScheduleModal;
